var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4656_1985)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1685 9.79434L14.4158 0.441968C14.7282 0.126038 15.2375 0.12316 15.5534 0.43554C15.5556 0.437671 15.5577 0.439813 15.5599 0.441968C15.8768 0.76254 15.8768 1.27848 15.5599 1.59905L5.77161 11.4985C5.71413 11.5567 5.64998 11.6042 5.5816 11.6411C5.27307 11.8313 4.86355 11.7939 4.5944 11.5278C4.59224 11.5257 4.5901 11.5235 4.58797 11.5214L0.393001 7.27875C0.076031 6.95818 0.076031 6.44224 0.393001 6.12166C0.705381 5.80573 1.21473 5.80286 1.53066 6.11524C1.53281 6.11737 1.53495 6.11951 1.53708 6.12166L5.1685 9.79434Z",
    fill: "#0BB873"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4656_1985"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightGreen);
export default __webpack_public_path__ + "static/media/right-green.484f7e1b23fbcfb390ee259159ce9db9.svg";
export { ForwardRef as ReactComponent };